import React, { type ReactElement } from 'react';

import ItemList, {
  type Detail,
} from '@/common/components/item-list/item-list.component';
import { type ExtraDetails } from '@/common/components/store-widget/store-widget.component';
import { isInstagramBrowser } from '@/common/utils/is-instagram-browser.utility';
import { generateIntentLink } from '@/common/utils/intent-link-creator.utility';
import { detectDeviceSystem } from '@/common/utils/detect-device-system';

import Instagram from '~/public/assets/images/svg/instagram-vendor-detail-icon.svg';
import Whatsapp from '~/public/assets/images/svg/whatsapp-vendor-detail-icon.svg';
import Telegram from '~/public/assets/images/svg/telegram-vendor-detail-icon.svg';
import Mobile from '~/public/assets/images/svg/mobile-vendor-detail-icon.svg';
import Telephone from '~/public/assets/images/svg/telephone-vendor-detail-icon.svg';

import VendorInfoDetailsItem from './vendor-info-details-item';

export interface Props {
  extraDetails: ExtraDetails;
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export default function VendorInfoDetails({
  extraDetails,
}: Props): ReactElement {
  const vendorSocialMediaInfoDetails: Detail[] = [
    ...((extraDetails.instagramAddress?.length ?? 0) > 0
      ? [
          {
            title: 'اینستاگرام:',
            detail: (
              <VendorInfoDetailsItem
                description={extraDetails.instagramAddress}
                icon={<Instagram />}
                type="url"
                intentLink={
                  isInstagramBrowser()
                    ? generateIntentLink(
                        detectDeviceSystem(),
                        'instagram',
                        extraDetails.instagramAddress.substring(
                          extraDetails.instagramAddress.lastIndexOf('/') + 1
                        )
                      )
                    : ''
                }
              />
            ),
          },
        ]
      : []),

    ...((extraDetails.telegramAddress?.length ?? 0) > 0
      ? [
          {
            title: 'تلگرام:',
            detail: (
              <VendorInfoDetailsItem
                description={extraDetails.telegramAddress}
                icon={<Telegram />}
                type="url"
                intentLink={
                  isInstagramBrowser()
                    ? generateIntentLink(
                        detectDeviceSystem(),
                        'telegram',
                        extraDetails.telegramAddress.substring(
                          extraDetails.telegramAddress.lastIndexOf('/') + 1
                        )
                      )
                    : ''
                }
              />
            ),
          },
        ]
      : []),

    ...((extraDetails.whatsAppAddress?.length ?? 0) > 0
      ? [
          {
            title: 'واتس‌آپ:',
            detail: (
              <VendorInfoDetailsItem
                description={extraDetails.whatsAppAddress}
                icon={<Whatsapp />}
                type="tel"
                intentLink={
                  isInstagramBrowser()
                    ? generateIntentLink(
                        detectDeviceSystem(),
                        'whatsapp',
                        extraDetails.whatsAppAddress.substring(
                          extraDetails.whatsAppAddress.lastIndexOf('/') + 1
                        )
                      )
                    : ''
                }
              />
            ),
          },
        ]
      : []),
  ];

  const vendorMobileInfoDetails: Detail[] = [
    ...((extraDetails.shopMobilePhone?.length ?? 0) > 0
      ? [
          {
            title: 'موبایل:',
            detail: (
              <VendorInfoDetailsItem
                description={extraDetails.shopMobilePhone || ''}
                icon={<Mobile />}
                type="tel"
              />
            ),
          },
        ]
      : []),

    ...((extraDetails.shopPhoneNumber?.length ?? 0) > 0
      ? [
          {
            title: 'تلفن:',
            detail: (
              <VendorInfoDetailsItem
                description={extraDetails.shopPhoneNumber || ''}
                icon={<Telephone />}
                type="tel"
              />
            ),
          },
        ]
      : []),
  ];

  const vendorAddressInfoDetails: Detail[] = [
    ...(extraDetails.address
      ? [
          {
            title: 'نشانی فروشگاه:',
            detail: extraDetails.address,
          },
        ]
      : []),
  ];
  return (
    <div className="mt-3 flex w-full flex-col gap-y-2 pb-6">
      <ItemList details={vendorSocialMediaInfoDetails} />

      <div className="flex w-full items-center justify-between gap-x-3">
        <ItemList className=" w-full " details={vendorMobileInfoDetails} />
      </div>

      <ItemList
        className=" !h-auto flex-col"
        details={vendorAddressInfoDetails}
      />
    </div>
  );
}
